import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { AgendamentoTable } from '../components/agendamento/AgendamentoTable';
import { AgendamentoFormModal } from '../components/modals/AgendamentoFormModal';
import { ApoliceFormModal } from '../components/apolice/ApoliceFormModal';
import type { Agendamento } from '../types/entities';
import type { ApoliceData } from '../services/apoliceService';

const AgendamentosPage: React.FC = () => {
  const [selectedAgendamento, setSelectedAgendamento] = useState<Agendamento | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  
  // Estado para modal de apólice
  const [apoliceModalOpen, setApoliceModalOpen] = useState(false);
  const [selectedApolice, setSelectedApolice] = useState<ApoliceData | undefined>();

  const handleCreateNew = () => {
    setSelectedAgendamento(undefined);
    setIsEditing(false);
    setModalOpen(true);
  };

  const handleEdit = (agendamento: Agendamento) => {
    setSelectedAgendamento(agendamento);
    setIsEditing(true);
    setModalOpen(true);
  };

  const handleView = (agendamento: Agendamento) => {
    setSelectedAgendamento(agendamento);
    setIsEditing(false);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setSelectedAgendamento(undefined);
    setIsEditing(false);
    setRefreshKey(k => k + 1);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setSelectedAgendamento(undefined);
    setIsEditing(false);
  };

  const handleOpenApolice = (apolice: any) => {
    setSelectedApolice(apolice);
    setApoliceModalOpen(true);
  };

  const handleApoliceClose = () => {
    setApoliceModalOpen(false);
    setSelectedApolice(undefined);
  };

  const handleApoliceSave = (apolice: ApoliceData) => {
    console.log('Apólice salva:', apolice);
    // Atualizar se necessário
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
                Gestão de Agendamentos
              </h1>
              <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
                Gerencie os agendamentos do sistema
              </p>
            </div>
            
            <button
              onClick={handleCreateNew}
              className="px-3 py-1.5 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Novo Agendamento
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <AgendamentoTable
              onEdit={handleEdit}
              onView={handleView}
              refreshKey={refreshKey}
              onDeleted={() => setRefreshKey(k => k + 1)}
            />
          </div>
        </div>
        
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>

      {/* Modal de Formulário */}
      {modalOpen && (
        <AgendamentoFormModal
          agendamento={selectedAgendamento}
          isOpen={modalOpen}
          isEditing={isEditing}
          onClose={handleCancel}
          onSuccess={handleSuccess}
          onOpenApolice={handleOpenApolice}
        />
      )}

      {/* Modal de Apólice */}
      {apoliceModalOpen && selectedApolice && (
        <ApoliceFormModal
          apolice={selectedApolice}
          isOpen={apoliceModalOpen}
          isEditing={true}
          onClose={handleApoliceClose}
          onSave={handleApoliceSave}
        />
      )}
    </div>
  );
};

export default AgendamentosPage;
